import { openSalesIQChat } from '../utils/openSalesIQChat';
import CallButton from './CallButton';

const issues = [
  {
    title: 'Sync Issues',
    description: 'Troubleshoot synchronization between devices and cloud services.',
  },
  {
    title: 'Upgrade Errors',
    description: 'Resolve install and upgrade problems when moving to a newer version.',
  },
  {
    title: 'Missing Trees',
    description: 'Recover family tree data and restore genealogy work you thought was lost.',
  },
  {
    title: 'Missing Media',
    description: 'Locate and reconnect photos, documents, and other attachments.',
  },
  {
    title: 'Display Glitches',
    description: 'Fix layout and display problems on desktop, tablet, or laptop screens.',
  },
  {
    title: 'Updates Not Saving',
    description: 'Make sure person edits and tree changes save and sync correctly.',
  },
];

export default function SupportIssues() {
  return (
    <section className="t7-section t7-section--wash" id="support-issues">
      <div className="container">
        <div className="t7-head t7-head--rail">
          <p className="t7-kicker">Troubleshooting</p>
          <h2 className="t7-title">Common issues we help with</h2>
          <p className="t7-lead">
            From sync hiccups to missing media—call or chat and we will walk you through a fix.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[#c5d9cb] border border-[#c5d9cb] mb-8 md:mb-10">
          {issues.map((issue) => (
            <article key={issue.title} className="bg-[#f7faf7] p-5 sm:p-6 md:p-8 hover:bg-white transition-colors">
              <h3 className="font-serif text-lg sm:text-xl text-[#14201a] mb-2">{issue.title}</h3>
              <p className="text-[#4d5c54] text-sm leading-relaxed m-0">{issue.description}</p>
            </article>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:justify-between border-t border-[#c5d9cb] pt-6 sm:pt-8">
          <p className="text-[#14201a] font-medium m-0">Need a hand right now?</p>
          <div className="t7-actions">
            <CallButton className="t7-btn t7-btn--green sm:w-auto" />
            <button type="button" className="t7-btn t7-btn--outline-dark sm:w-auto" onClick={openSalesIQChat}>
              Chat Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
